import { render, staticRenderFns } from "./ImageTextCtaIcons.vue?vue&type=template&id=bb90b8e2"
import script from "./ImageTextCtaIcons.vue?vue&type=script&lang=js"
export * from "./ImageTextCtaIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports